export interface RequestParamPersonalizationEngine {
  campaignId: string | string[];
  format: string;
}

export interface PersonalizationEngineRequest {
  userdata: Partial<UserData>;
  requestparam: Partial<RequestParamPersonalizationEngine>;
}

export interface UserData extends Partial<FlightData> {
  baseFare: number;
  beforeDeparturePenaltyWaived: boolean;
  cancelEligibility: boolean;
  cancelEligibilityDesc: string;
  cancelFee: number;
  changeEligibility: boolean;
  changeEligibilityDesc: string;
  changeFee: number | string;
  displayAvailableECreditsDropdown: boolean;
  eliteStatus: string;
  fareBasisCode: string;
  firstUnflownTripDepartureHourCnt: number;
  firstUnflownTripSameDayCountry: boolean;
  hasEquivalentFare: boolean;
  invalidResponse: boolean;
  originalFee: number | string;
  refundableTicket: boolean;
  riskFreeEligibility: boolean;
  secondUnflownTripDepartureHourCnt: number;
  secondUnflownTripSameDayCountry: boolean;
  ticketDesignator: string;
  ticketStock: string;
  ticketType: string;
  ticketValue: string;
  totalChangeFee: string;
  travelWithin: boolean;
  trip1PriorToDepartureHourCnt: number;
  trip2PriorToDepartureHourCnt: number;
  tripCount: number;
  unflownItinerary: boolean;
  unflownTripCount: number;
}

export interface FlightData {
  origin: string;
  destination: string;
  departuredate: string;
  flightName: string;
  flightCode: string;
  subFlightCode: string;
  operatingAirlineCode: string;
  triptype: string;
  returndate: string;
  noofpassengers: number;
  country: string;
  mktCpgn: string;
  shopType: string;
  OriginDestinationPair: string;
}

export interface RequestParam {
  campaignId: string;
  format: string;
}

export interface PersonalizationEngineResponse {
  format: string;
  finalcontentPath: string;
  contentDetails: ContentDetails;
}

export interface ContentDetails {
  analyticsPageName: string;
  parsys: Parsys;
  interstitialbanner?: Interstitialbanner;
}

export interface Parsys {
  router: Router;
}

export interface Router {
  endpoint: string;
}

export interface LocalStorageContent {
  redirectUrl: string;
  expiresIn: number;
}

export interface Interstitialbanner {
  description: string;
  descriptionalignment: string;
  desktopimagepath: string;
  header: string;
  headeralignment: string;
  marketingDesktopImage: string;
  marketingMobileImage: string;
  responsivedesktopimagepath: string;
  responsivemobileimagepath: string;
  textposition: string;
  responsiveimgalttext: string;
  imgalttext: string;
  loadingText: string;
  descriptionfontsize: string;
}
